import { getAdditionalNotes } from "@stryker/core/api/jobs";
import { QueryKeys } from "@stryker/core/queryKeys";
import type { JobTypeName, NotesData } from "@stryker/core/types/jobs";
import { queryOptions } from "@tanstack/react-query";

export type AdditionalNotesJobType = JobTypeName;

export const additionalNotesQueryOptions = (jobType?: AdditionalNotesJobType) =>
  queryOptions<NotesData>({
    queryKey: [QueryKeys.AdditionalNotes, jobType ?? "allowed"],
    queryFn: () => getAdditionalNotes(jobType),
    staleTime: 5 * 60 * 1000,
  });
